module.exports = __webpack_public_path__ + "img/17.1a78b429.jpeg";